import type { ReactNode } from 'react';
// @ts-ignore — CSS module sin tipos
import styles from './AdriHeaderButton.module.css';
import { useAdriStore } from '../../stores/useAdriStore';
import AdriAvatar from '../AdriAvatar/AdriAvatar';
import NudgeCard from '../NudgeCard/NudgeCard';

interface AdriHeaderButtonProps {
  /** T065 — NudgeCard anclado bajo el botón (el contenedor es position:relative). */
  children?: ReactNode;
}

/**
 * 051 — Botón de Adri en el header (T068): ocupa el lugar del antiguo enlace de
 * WhatsApp "¿Necesitas ayuda?". El punto se enciende SOLO con un mensaje sin
 * leer o un empujón nuevo, nunca por tener pasos pendientes en la ruta.
 */
const AdriHeaderButton = ({ children }: AdriHeaderButtonProps) => {
  const isOpen = useAdriStore((s) => s.isOpen);
  const toggle = useAdriStore((s) => s.toggle);
  const unreadCount = useAdriStore((s) => s.unreadCount);
  const hasNudge = useAdriStore((s) => !!s.route?.nudge);
  const showDot = unreadCount > 0 || hasNudge;

  const label = showDot
    ? unreadCount > 0
      ? `Abrir Adri, tienes ${unreadCount} ${unreadCount === 1 ? 'mensaje sin leer' : 'mensajes sin leer'}`
      : 'Abrir Adri, tienes una sugerencia nueva'
    : isOpen
      ? 'Cerrar Adri'
      : 'Abrir Adri, tu asistente de Prikly';

  return (
    <div className={styles.container}>
      <button
        type="button"
        className={`${styles.trigger} ${isOpen ? styles.active : ''}`}
        onClick={() => toggle()}
        aria-label={label}
        aria-expanded={isOpen}
        title="Adri, tu asistente de Prikly"
        data-testid="adri-header-button"
      >
        <AdriAvatar size={30} />
        <span className={styles.label}>Adri</span>
        {showDot && <span className={styles.dot} data-testid="adri-dot" aria-hidden="true" />}
      </button>
      <NudgeCard />
      {children}
    </div>
  );
};

export default AdriHeaderButton;
